import normalizeTypography from '@shared/pieve/normalizeTypography.js';

const normalizeTextNodes = (node) => {
  if (node.type === 'text') {
    node.value = normalizeTypography(node.value);
    return;
  }

  (node.children || []).forEach(normalizeTextNodes);
};

/**
 * A remark plugin that runs normalizeTypography over the prose of a Markdown document. Code spans
 * and code blocks are separate node types, so code keeps its characters exactly.
 */
const remarkNormalizeTypography = () => {
  return (tree) => {
    normalizeTextNodes(tree);
  };
};

export default remarkNormalizeTypography;
